var map = {
	"./en/odyssey.json": 66657,
	"./es/odyssey.json": 74851,
	"./fr/odyssey.json": 82755,
	"./ja/odyssey.json": 26616,
	"./kr/odyssey.json": 50645,
	"./th/odyssey.json": 20041,
	"./tr/odyssey.json": 80027,
	"./vi/odyssey.json": 83210
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30921;